<template>
    <el-button type="danger" class="pull-right" plain round style="margin:20px;" @click="resetData">Initialize Sample Data</el-button>
</template>

<script>
import po1 from './SampleData/1. Brand New Project PO.json'
import po2 from './SampleData/2. New PO for same project.json'
import po3 from './SampleData/3. New PO for SIMILAR project.json'
import po4 from './SampleData/4. Reschedule for Original PO.json'
import po5 from './SampleData/5. Changes for Original PO.json'
import po6 from './SampleData/6. Cancellation for Original PO.json'
import po7 from './SampleData/7. Multiple Job PO.json'
import po8 from './SampleData/8. Reschedule for Multiple Job PO.json'
import po9 from './SampleData/9. Changes for Multiple Job PO.json'
import po10 from './SampleData/10. Cancellation for Multiple Job PO.json'

import {ptracDeleteEntity, ptracPost} from '@/utilities/ptracApi'
import {notifySuccess} from '@/utilities/utils'

export default {
    methods: {
        async resetData() {
            // delete all POs, and SupplyPro specific metadata
            await ptracDeleteEntity('supply-pro-purchase-orders/deleteAll/')
            await ptracDeleteEntity('supply-pro-change-purchase-orders/deleteAll/')
            await ptracDeleteEntity('metadata/deleteAllSupplyPro/')

            // POST the 10 SampleData POs
            await ptracPost('supply-pro-purchase-orders/', po1)
            await ptracPost('supply-pro-purchase-orders/', po2)
            await ptracPost('supply-pro-purchase-orders/', po3)
            await ptracPost('supply-pro-change-purchase-orders/', po4)
            await ptracPost('supply-pro-change-purchase-orders/', po5)
            await ptracPost('supply-pro-change-purchase-orders/', po6)
            await ptracPost('supply-pro-purchase-orders/', po7)
            await ptracPost('supply-pro-change-purchase-orders/', po8)
            await ptracPost('supply-pro-change-purchase-orders/', po9)
            await ptracPost('supply-pro-change-purchase-orders/', po10)

            notifySuccess(this, 'SupplyPro data has been reset!')
            this.$emit('resetSampleData')
        }
    }
}
</script>
